import LandingView from './LandingView';
import './style.scss';

export default LandingView;
